import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function getPresignedPayPlanPDF(...params) {
	const [locationId, position, pdfType, fileName] = params;

	const query = gql`
		query getPresignedPayPlanPDF($locationId: String!, $position: String!, $pdfType: String!, $fileName: String!) {
			getPresignedPayPlanPDF(locationId: $locationId, position: $position, pdfType: $pdfType, fileName: $fileName) {
				fileName
				presignedURL
			}
		}
	`;

	const variables = {
		locationId,
		position,
		pdfType,
		fileName,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response?.data?.data?.getPresignedPayPlanPDF;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}
